import React from 'react';

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,500;0,700;1,500&family=DM+Sans:wght@300;400;500;600&display=swap');
.ab-page{font-family:'DM Sans',sans-serif;background:#f5f4f0;min-height:100vh;}
.ab-hero{position:relative;overflow:hidden;padding:4rem 2rem 3.5rem;background:linear-gradient(135deg,#0b3d4a 0%,#134d5e 55%,#1a6474 100%);}
.ab-orb{position:absolute;border-radius:50%;filter:blur(80px);opacity:.15;pointer-events:none;}
.ab-orb--a{width:500px;height:500px;background:radial-gradient(circle,#e67e22,transparent);top:-120px;right:-80px;}
.ab-orb--b{width:350px;height:350px;background:radial-gradient(circle,#2196a4,transparent);bottom:-80px;left:-60px;}
.ab-hero-inner{position:relative;z-index:1;max-width:780px;margin:0 auto;text-align:center;}
.ab-hero-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(255,255,255,.1);border:1px solid rgba(255,255,255,.2);color:rgba(255,255,255,.85);font-size:.75rem;letter-spacing:.08em;padding:5px 14px;border-radius:999px;margin-bottom:1.25rem;}
.ab-h1{font-family:'Playfair Display',Georgia,serif;font-size:clamp(2rem,5vw,3.2rem);font-weight:700;color:#fff;line-height:1.15;margin:0 0 1rem;}
.ab-gold{background:linear-gradient(90deg,#f39c12,#e67e22);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}
.ab-hero-sub{font-size:1rem;color:rgba(255,255,255,.68);line-height:1.7;max-width:52ch;margin:0 auto;}
.ab-body{max-width:1100px;margin:0 auto;padding:4rem 2rem;}
.ab-section{margin-bottom:4rem;}
.ab-slabel{font-size:.68rem;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:#21808d;margin-bottom:.4rem;}
.ab-h2{font-family:'Playfair Display',Georgia,serif;font-size:clamp(1.6rem,3vw,2.2rem);font-weight:700;color:#0b3d4a;margin:0 0 1.25rem;}
.ab-txt{font-size:.97rem;color:#555;line-height:1.78;margin-bottom:.85rem;}
.ab-pillars-g{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:1rem;margin-top:1.25rem;}
.ab-pcard{background:#fff;border-radius:12px;padding:1.5rem;border-top:4px solid var(--c,#21808d);box-shadow:0 2px 10px rgba(0,0,0,.05);transition:transform .2s,box-shadow .2s;}
.ab-pcard:hover{transform:translateY(-4px);box-shadow:0 10px 28px rgba(0,0,0,.1);}
.ab-pcard-icon{font-size:1.6rem;margin-bottom:.5rem;display:block;}
.ab-pcard-name{font-family:'Playfair Display',serif;font-size:1rem;font-weight:600;color:#0b3d4a;margin:0 0 .3rem;}
.ab-pcard-desc{font-size:.82rem;color:#777;line-height:1.6;margin:0;}
.ab-jlist{list-style:none;padding:0;margin:.75rem 0 0;display:flex;flex-direction:column;gap:.6rem;}
.ab-jlist li{display:flex;align-items:center;gap:.75rem;font-size:.95rem;color:#444;background:#fff;padding:.75rem 1rem;border-radius:10px;border-left:4px solid #21808d;box-shadow:0 1px 6px rgba(0,0,0,.05);}
.ab-jlist li::before{content:'✦';color:#f39c12;font-size:.72rem;}
.ab-benefits{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:1rem;margin-top:1.25rem;}
.ab-bcard{background:#fff;border-radius:12px;padding:1.5rem;text-align:center;box-shadow:0 2px 10px rgba(0,0,0,.05);transition:transform .2s,box-shadow .2s;}
.ab-bcard:hover{transform:translateY(-4px);box-shadow:0 10px 28px rgba(0,0,0,.1);}
.ab-bcard-icon{font-size:2rem;margin-bottom:.75rem;display:block;}
.ab-bcard-title{font-family:'Playfair Display',serif;font-size:.97rem;font-weight:600;color:#0b3d4a;margin:0 0 .4rem;}
.ab-bcard-desc{font-size:.82rem;color:#777;line-height:1.6;margin:0;}
.ab-hr{border:none;border-top:1px solid rgba(0,0,0,.08);margin:2.5rem 0;}
@media(max-width:600px){.ab-hero{padding:3rem 1.25rem 2.5rem;}.ab-body{padding:2.5rem 1.25rem;}}
`;

export default function About() {
  return (
    <div className="ab-page">
      <style>{CSS}</style>
      <div className="ab-hero">
        <div className="ab-orb ab-orb--a"/><div className="ab-orb ab-orb--b"/>
        <div className="ab-hero-inner">
          <div className="ab-hero-badge">🙏 MSME Registered · Est. 2020</div>
          <h1 className="ab-h1">About <span className="ab-gold">Viveka Seva Trust</span></h1>
          <p className="ab-hero-sub">A youth-driven service movement from Bengaluru, committed to nation-building through education, healthcare, and community upliftment.</p>
        </div>
      </div>
      <div className="ab-body">
        <div className="ab-section">
          <div className="ab-slabel">Our Story</div>
          <h2 className="ab-h2">Who Are We?</h2>
          <p className="ab-txt">Viveka Seva Trust is an MSME-registered community organization dedicated to education and social services, primarily serving government schools across Karnataka.</p>
          <p className="ab-txt">Inspired by Swami Vivekananda's teachings, Viveka Seva was established in 2020 and officially registered in 2025. We are a youth-driven, service-oriented movement from Bengaluru, committed to nation-building through education as our primary tool.</p>
          <p className="ab-txt">Guided by our motto — <em>"Service to Mankind is Service to God"</em> — and blessed by Sri Ramakrishna, Swami Vivekananda, and Holy Maa Sharada Devi, we work towards creating positive change for the needy and deprived since 2020.</p>
        </div>
        <hr className="ab-hr"/>
        <div className="ab-section">
          <div className="ab-slabel">Where We're Headed</div>
          <h2 className="ab-h2">Our Vision</h2>
          <p className="ab-txt">To strive towards a better society by strengthening the pillars of Education, Healthcare, Spirituality, and Environmental Sustainability.</p>
          <div className="ab-pillars-g">
            {[{icon:'📚',name:'Education',desc:'Quality learning for all',c:'#21808d'},{icon:'🏥',name:'Healthcare',desc:'Accessible medical services',c:'#e67e22'},{icon:'🙏',name:'Spirituality',desc:'Inner growth and awakening',c:'#8e44ad'},{icon:'🌿',name:'Environment',desc:'Protecting our planet',c:'#27ae60'}].map((p,i)=>(
              <div key={i} className="ab-pcard" style={{'--c':p.c}}>
                <span className="ab-pcard-icon">{p.icon}</span>
                <p className="ab-pcard-name">{p.name}</p>
                <p className="ab-pcard-desc">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
        <hr className="ab-hr"/>
        <div className="ab-section">
          <div className="ab-slabel">Our Purpose</div>
          <h2 className="ab-h2">Our Mission</h2>
          <p className="ab-txt">To provide holistic education, accessible healthcare, environmental sustainable practices, and nurture spiritual growth — thereby fostering a harmonious and thriving society.</p>
        </div>
        <hr className="ab-hr"/>
        <div className="ab-section">
          <div className="ab-slabel">Open Doors</div>
          <h2 className="ab-h2">Who Can Join Us?</h2>
          <p className="ab-txt">We welcome anyone interested in serving communities without political agenda. If you believe in Swami Vivekananda's vision of a strong, compassionate India, you belong here.</p>
          <ul className="ab-jlist">
            <li>Non-political, non-profit community service</li>
            <li>Grassroots-level social activities</li>
            <li>Working towards Swami Vivekananda's vision</li>
          </ul>
        </div>
        <hr className="ab-hr"/>
        <div className="ab-section">
          <div className="ab-slabel">Your Benefits</div>
          <h2 className="ab-h2">Why Join Us?</h2>
          <div className="ab-benefits">
            {[{icon:'🌟',title:'Be Part of Nation Building',desc:'Join hands in this meaningful exercise of creating positive change.'},{icon:'🎓',title:"Experience Education's Impact",desc:'Witness the transformative power of education at its grassroots level.'},{icon:'💝',title:'Find Joy in Giving',desc:'Experience the profound satisfaction that comes from serving others.'},{icon:'📜',title:'Earn Service Certification',desc:'Obtain MSME-registered Service Certification after completing community service hours.'}].map((b,i)=>(
              <div key={i} className="ab-bcard">
                <span className="ab-bcard-icon">{b.icon}</span>
                <p className="ab-bcard-title">{b.title}</p>
                <p className="ab-bcard-desc">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}